import React from "react";
import PanZoom from "react-easy-panzoom";

const PanZoomController = ({ children, panZoomRef }) => {

  const handleOnPanStart =(e)=>{
  }

  const handleOnPan =(e)=>{
    if(panZoomRef.current && e.buttons===0){
     panZoomRef.current.onMouseUp()
     return
    }
  }

  const handleOnPanEnd =(e)=>{
  }
 
  return (
    <>
        <PanZoom
          disableDoubleClickZoom={true}
          onPanStart={handleOnPanStart}  
          onPan={handleOnPan}
          onPanEnd={handleOnPanEnd}  
          ref={panZoomRef}
        >
          {children}
        </PanZoom>
        ;
    </>
  );
};

export default PanZoomController;
